
export default {
  data() {
    return {
      openInstructions: false
    };
  }
};
